import React, { Fragment } from 'react'

import { withTranslation } from 'react-i18next'
import styled from 'styled-components'

import Icon, { IconNames } from 'components/icons'
import Message from 'components/message'

const MessageContent = styled.div`
  & div {
    max-width: 1200px;
  }
  width: 100%;
  background-color: ${({ theme }) => theme.colors.yellowLight};
  display: flex;
  justify-content: center;
`

const AlertMessage = styled.div`
  & a {
    color: ${({ theme }) => theme.colors.doveGrayer};
    font-family: ${({ theme }) => theme.fonts.semiBold};
  }
  & p {
    display: inline;
  }
`

const CrossIcon = styled(Icon)`
  float: right;
  margin: 15px 15px 14px 0;
  &:hover {
    cursor: pointer;
  }
`
const CrossButton = styled.button`
  background-color: ${({ theme }) => theme.colors.transparent};
  border: none;
  outline: none;
`

class AlertsContainer extends React.Component {
  state = {
    display: []
  }

  handleClick = index => {
    this.setState(prevState => ({
      display: [...prevState.display, index]
    }))
  }

  render() {
    const { t } = this.props
    return (
      <Fragment>
        {this.props.alerts &&
          this.props.alerts.map(
            (alerts, index) =>
              !this.state.display.includes(index) && (
                <MessageContent key={index}>
                  <Message type="warning">
                    <AlertMessage dangerouslySetInnerHTML={{ __html: alerts.alertMessage }} />
                  </Message>
                  <CrossButton
                    onClick={() => this.handleClick(index)}
                    aria-label={t('alt.close-modal')}
                  >
                    <CrossIcon name={IconNames.Close} size={20} />
                  </CrossButton>
                </MessageContent>
              )
          )}
      </Fragment>
    )
  }
}

export default withTranslation()(AlertsContainer)
